import { decodePoster } from '@/scripts/core/media-poster'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class ArtDirection extends UcoastEl {
	static htmlSelector = 'art-direction'
	get posterFirst() {
		return this.hasAttribute('data-poster-first')
	}
	private preparation?: Promise<void>

	override connectedCallback() {
		super.connectedCallback()
		if (this.hasAttribute('data-media-deferred'))
			window.Ucoast?.mediaManager?.addDeferredMedia(this)
		else if (this.posterFirst && !this.querySelector('ucoast-video'))
			void this.prepare()
	}

	async prepare() {
		this.preparation ??= this.prepareImage()
		return this.preparation
	}

	private async prepareImage() {
		const template = this.querySelector<HTMLTemplateElement>(
			'template[data-deferred-media]'
		)
		if (template) {
			template.replaceWith(template.content.cloneNode(true))
			this.removeAttribute('data-media-deferred')
		}
		const image = this.querySelector('img')
		if (image) {
			image.style.visibility = this.posterFirst ? '' : 'hidden'
			const decoded = await decodePoster(image)
			if (!this.isConnected) return
			if (decoded === true) {
				if (!this.posterFirst) image.style.visibility = ''
			} else {
				image.style.visibility = 'hidden'
				const recover = () => {
					if (!this.isConnected || image.naturalWidth < 1) return
					void image.decode().then(
						() => {
							if (!this.isConnected || image.naturalWidth < 1) return
							image.style.visibility = ''
							this.querySelector('.media-retry')?.remove()
							this.onMediaLoad()
						},
						() => {}
					)
				}
				image.addEventListener(
					'load',
					recover,
					{ once: true }
				)
				if (image.complete && image.naturalWidth > 0) recover()
			}
			if (decoded !== true && !this.querySelector('ucoast-video')) {
				const retry = document.createElement('button')
				retry.type = 'button'
				retry.className = 'button media-retry'
				retry.textContent = this.dataset.retryLabel ?? ''
				retry.addEventListener(
					'click',
					() => {
						retry.remove()
						this.preparation = undefined
						image.replaceWith(image.cloneNode(true))
						void this.prepare()
					},
					{ once: true }
				)
				this.append(retry)
			}
		}
		if (this.isConnected && !this.querySelector('ucoast-video'))
			this.onMediaLoad()
	}

	isTouchingViewport() {
		const rect = this.getBoundingClientRect()
		return rect.top < innerHeight && rect.bottom > 0
	}
	isHiddenForViewport() {
		const rect = this.getBoundingClientRect()
		return rect.width < 1 || rect.height < 1
	}

	override disconnectedCallback() {
		super.disconnectedCallback()
		window.Ucoast?.mediaManager?.removeDeferredMedia(this)
	}

	onMediaLoad() {
		this.classList.add('loaded')
	}
}
